jQuery(document).ready(function($){

	// ================== Story boxy ==================
	var stories = [];
	var Story = function($elem) {
		this.elem = $elem;
		this.slider = $elem.find('.story-box__slider');
		this.image = $elem.find('.story-box__img--after');
		this.active = false;

		this.change = function() {
			if (this.active) {
				this.slider.removeClass('story-box__slider--active');
				this.image.removeClass('story-box__img--active');
				this.active = false;
			} else {
				this.slider.addClass('story-box__slider--active');
				this.image.addClass('story-box__img--active');
				this.active = true;
			}
		}

		this.onClick = function() {
			this.change();

			return false;
		}

		var that = this;
		this.slider.click(function(e){
			e.preventDefault();
			return that.onClick();
		});
	};

	// Aktivuje přepínače váhy ve všech story-boxech
	$('.jq-story').each(function(){
		var story = new Story($(this));
		stories.push(story);
	});

	// ================== Filtr boxů ==================
	var Filter = {
		slider: $('#jq-range-slider'),
		minElem: $('#jq-range-slider-min'),
		maxElem: $('#jq-range-slider-max'),
		sexElem: $('.jq-story-filter-sex'),
		sex: [true, true],
		sortElem: $('#jq-story-list'),
		sexClass: 'story-filter__sex-item--active'
	};
	Filter.init = function() {
		Filter.slider.noUiSlider({
			start: [18, 99],
			range: {
				'min': 18,
				'max': 99
			},
			step: 1,
			margin: 5,
			connect: true,
			format: wNumb({
				decimals: 0
			})
		});

		Filter.slider.Link('lower').to(Filter.minElem);
		Filter.slider.Link('upper').to(Filter.maxElem);
		Filter.sexElem.click(Filter.sexChanged);

		Filter.slider.on('change', Filter.rangeChanged);

		Filter.sortElem.shuffle({
			itemSelector: '.jq-story',
			sizer: $('#jq-story-list .jq-story')

		});
	};

	Filter.show = function() {
		Filter.sortElem.shuffle('shuffle', function($elem, shuffle) {
			var age = $elem.data('age');
			var range = Filter.slider.val();
			var showAge, showSex = false;

			if (age >= range[0] && age <= range[1])
				showAge = true;

			if ($elem.data('sex') == 'man' && Filter.sex[0])
				showSex = true;
			else if ($elem.data('sex') == 'woman' && Filter.sex[1])
				showSex = true;

			return (showAge && showSex);
		});
	}

	Filter.rangeChanged = function() {
		Filter.show();
	};

	Filter.sexChanged = function() {
		var $elem = $(this);
		var sexActual = parseInt($elem.data('filter-sex'));
		var sexOther = sexActual == 1 ? 0 : 1;

		if (Filter.sex[0] && Filter.sex[1]) {
			Filter.sex[sexOther] = false;
			$elem.toggleClass(Filter.sexClass);
		}
		else if (Filter.sex[sexActual]) {
			Filter.sex[0] = true;
			Filter.sex[1] = true;
			Filter.sexElem.removeClass(Filter.sexClass);
		} else {
			Filter.sex[0] = !Filter.sex[0];
			Filter.sex[1] = !Filter.sex[1];
			Filter.sexElem.toggleClass(Filter.sexClass);
		}

		Filter.show();
	}

	if($('#jq-story-list').length == 1)
		Filter.init();

});